import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import messages from './simulatedQuestionLogHistoryMessages';
import moment from 'moment';
import { StatusBadge, Card } from 'sa-ui';

import './SimulatedQuestionLogHistory.scss';

const SimulatedQuestionLogHistory = props => (
  <Card>
    <div className="simulated-question-log-history">
      <h6>{props.intl.formatMessage(messages.history)}</h6>
      {props.data.map(d => (
        <Fragment>
          <div>
            <div className="status-badge--container">
              <StatusBadge variant="primary">
                {moment(d.added).format('DD/MM/YYYY HH:mm:ss')}
              </StatusBadge>
            </div>
            <strong>{props.intl.formatMessage(messages.comments)}: </strong>
            <em>{d.comments}</em>
            <div className="added-by">
              <strong>{props.intl.formatMessage(messages.addedBy)}:</strong> {d.userName}
            </div>
          </div>
          <hr />
        </Fragment>
      ))}
    </div>
  </Card>
);

SimulatedQuestionLogHistory.propTypes = {};

export default injectIntl(SimulatedQuestionLogHistory);
